








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { IncomeTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxIncomeType extends Vue {
  private types: IncomeTypeDto[] | null = [];
  public selectedType = new IncomeTypeDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: IncomeTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: IncomeTypeDto) {
    this.$emit("incomeTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .incomeType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
